

export enum Authority {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_USER = 'ROLE_USER',
    ROLE_INVESTOR = 'ROLE_INVESTOR',
}